import { useEffect, useState } from "react"
import { useLocation, useNavigate, useSearchParams } from "react-router-dom"
import styled from "styled-components"
import { MovieElementDiv, slugify } from "../../Components/MoviesSlider"
import PaginationMovies from "../../Components/PaginationMovies"
import { MoviesDiv } from "../MoviesList"
import { AddBannerDiv } from "../Home"
import AdsterraBanner from "../../Components/AdsterraBanner"
import ExoClickBanner728x90 from "../../Components/ExoClickBanner728x90"
import ExoClickBannerMobile from "../../Components/ExoClickBannerMobile"
import AdsterraNativeBanner from "../../Components/AdsterraNativeBanner"

const ResultsContainer = styled.div`
    height: 100%;
    padding: 90px 10px;
    @media screen and (min-width: 768px) {
        padding: 100px 120px;
    }
    @media screen and (min-width: 768px) and (max-width: 1024px) {
        padding: 100px 20px;
    }
`

function Search() {
    const location = useLocation()
    const [searchParams] = useSearchParams()

    const query = searchParams.get("q")

    const [currentPage, setCurrentPage] = useState(1)
    const moviesPerPage = 36

    const results = location.state.results
    const totalPages = Math.ceil(results.length / moviesPerPage)

    // Calculer les éléments de la page courante
    const start = (currentPage - 1) * moviesPerPage
    const end = start + moviesPerPage
    const currentMovies = results.slice(start, end)

    //const [loading, setLoading] = useState(true)

    const handlePageChange = (page) => {
        setCurrentPage(page)
        if (page >= 1 && page <= totalPages) {
            /*
            const newParams = new URLSearchParams(searchParams)
            newParams.set("page", page.toString())
            if (query) newParams.set("q", query)

            setSearchParams(newParams, { replace: false })
            */
            window.scrollTo(0, 0)
        }
    }

    const navigate = useNavigate()
    const movieHandleClick = (id, titre, source) => {
        const urlTitle = slugify(titre)

        if (source === "Films") {
            navigate(`/Film/${urlTitle}?film_id=${id}`)
        } else if (source === "Series") {
            navigate(`/serie/${urlTitle}?serie_id=${id}`)
        }
    }

    useEffect(() => {
        document.title = `Recherche ${query ?? ""} sur Streamflix-fr`
    })

    const isMobile = window.innerWidth < 768

    return (
        <ResultsContainer>
            {/*<AddBannerDiv>
                {isMobile ? <ExoClickBannerMobile /> : <ExoClickBanner728x90 />}
            </AddBannerDiv>*/}

            <MoviesDiv>
                {currentMovies.length > 0 ? (
                    currentMovies.map(({ id, titre, cover, source }) => (
                        <MovieElementDiv
                            key={id}
                            onClick={() => movieHandleClick(id, titre, source)}
                        >
                            <img src={cover} alt="Movies cover" />
                            <p>{titre}</p>
                        </MovieElementDiv>
                    ))
                ) : (
                    <h2>
                        Oups ! Il semble qu’on n’arrive pas à trouver de
                        résultats pour votre recherche "{query}"
                    </h2>
                )}
            </MoviesDiv>

            <AddBannerDiv>
                <p>
                    Cliquer sur les pub est le meilleur moyen de nous soutenir
                </p>
                {isMobile ? (
                    <AdsterraBanner
                        keyId="0ce49bfc0a6847270e97cef8117bdaff"
                        width={468}
                        height={60}
                    />
                ) : (
                    <AdsterraNativeBanner />
                )}
            </AddBannerDiv>

            {/*<AddBannerDiv>
                <p>
                    Cliquer sur les pub est le meilleur moyen de nous soutenir
                </p>
                {isMobile ? (
                    <AdsterraBanner
                        keyId="36095d1eafe994c25e794db19ac32ddd"
                        width={320}
                        height={50}
                    />
                ) : (
                    <AdsterraBanner
                        keyId="dcfa5d9b41f84b62a0d227806e4b1618"
                        width={728}
                        height={90}
                    />
                )}
            </AddBannerDiv>*/}

            {currentMovies.length > 0 ? (
                <PaginationMovies
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                />
            ) : (
                <p></p>
            )}
        </ResultsContainer>
    )
}

export default Search
